import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { IWorkplaceGroupDetails } from '@api/types'
import { WorkplaceGroupDetails } from '@api/fragments'

interface Payload {
  data: {
    node: IWorkplaceGroupDetails
  }
}

export const workplaceGroupDetailsQuery = gql`
  query WorkplaceGroup($id: ID!) {
    node(id: $id) {
      ... on WorkplaceGroup {
        ...WorkplaceGroupDetails
      }
    }
  }
  ${WorkplaceGroupDetails}
`

export default function details({
  workplaceGroupId,
}: {
  workplaceGroupId: string
}): Promise<IWorkplaceGroupDetails> {
  return client.gql
    .query({
      query: workplaceGroupDetailsQuery,
      variables: {
        id: workplaceGroupId,
      },
    })
    .then(({ data: { node } }: Payload) => node)
}
